import { render, staticRenderFns } from "./Escolas.vue?vue&type=template&id=51fccd0c"
import script from "./Escolas.vue?vue&type=script&lang=js"
export * from "./Escolas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports